// Self-hosted so a lane with no internet still renders; a failed remote @import
// would reject the entry chunk's CSS preload and leave the app unmounted.
import '@fontsource-variable/roboto/wght.css';
import '@fontsource-variable/roboto/wght-italic.css';

function isCustomerDisplayPath(): boolean {
  const path = window.location.pathname;
  return path === '/customer-display' || path === '/customer-display/';
}

if (isCustomerDisplayPath()) {
  void import('./customerDisplay/customerDisplayEntry').then(({ mountCustomerDisplay }) => {
    mountCustomerDisplay();
  });
} else {
  void import('./posEntry').then(({ mountPos }) => {
    mountPos();
  });
}
